import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { env } from "@/src/common/constants/env";

interface PageHelmetProps {
	title: string;
	description?: string;
	type?: "website" | "article";
}

const OG_IMAGE_PATH = "/og-image.png";

export function PageHelmet({ title, description, type = "website" }: PageHelmetProps) {
	const { pathname } = useLocation();
	const { i18n } = useTranslation();
	const canonicalUrl = `${env.SITE_URL}${pathname === "/" ? "" : pathname}`;
	const fullTitle = `${title} | ${env.APP_NAME}`;
	const ogImageUrl = `${env.SITE_URL}${OG_IMAGE_PATH}`;
	const currentLang = i18n.resolvedLanguage ?? i18n.language;

	return (
		<Helmet defaultTitle={env.APP_NAME} titleTemplate={`%s | ${env.APP_NAME}`} title={title}>
			<html lang={currentLang} />
			<link rel="canonical" href={canonicalUrl} />

			{description ? <meta name="description" content={description} /> : null}

			<meta property="og:title" content={fullTitle} />
			<meta property="og:type" content={type} />
			<meta property="og:url" content={canonicalUrl} />
			<meta property="og:image" content={ogImageUrl} />
			<meta property="og:site_name" content={env.APP_NAME} />
			<meta property="og:locale" content={currentLang === "fr" ? "fr_FR" : "en_US"} />
			{description ? <meta property="og:description" content={description} /> : null}

			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={fullTitle} />
			<meta name="twitter:image" content={ogImageUrl} />
			{description ? <meta name="twitter:description" content={description} /> : null}
		</Helmet>
	);
}
